import authOnlyRoutes from './auth-only-routes';
import noAuthOnlyRoutes from './no-auth-only-routes';
import routeMap from './route-map';

export { authOnlyRoutes, noAuthOnlyRoutes };
export default routeMap;
